import { FC } from 'react';
import { Text } from '@chakra-ui/react';

import { WorkflowStepFormFieldNumberInput } from '../types/workflowStepComponentTypes';
import { FieldToBlock, FieldValueProps } from './declarations';
import { commonFieldBlockProps } from './FieldUtils';

export const IntegerFieldToBlock: FieldToBlock<
  'integer',
  WorkflowStepFormFieldNumberInput
> = (field) => ({
  ...commonFieldBlockProps(field),
  componentType: 'number-input',
  componentProps: {
    thousandSeparator: false,
    size: 'sm',
  },
});

type IntegerFieldValueProps = FieldValueProps<'integer'>;

export const IntegerFieldValue: FC<IntegerFieldValueProps> = ({ field }) => (
  <Text>{field.value}</Text>
);
